"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const SimpleModal_1 = __importDefault(require("components/Dashboard/SimpleModal"));
//
// components
//
const AllPages = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./AllPages'))));
const ArchivedPages = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./ArchivedPages'))));
const TabNavigation = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../TabNavigation'))));
const TrackingPageModal_1 = __importDefault(require("components/Dashboard/Modals/TrackingPageModal"));
const LoadingSpinner_1 = __importDefault(require("components/general/LoadingSpinner"));
//
// assets
//
const trackingCopy_1 = require("copy/trackingCopy");
//
// styles
//
const StyledHeader_1 = require("./StyledHeader");
const StyledHeaderContainer_1 = require("./StyledHeaderContainer");
const StyledContent_1 = require("./StyledContent");
const StyledMessageContainer_1 = require("components/Dashboard/StyledMessageContainer");
const StyledMainContainer_1 = require("components/Dashboard/StyledMainContainer");
const StyledButton_1 = require("components/Dashboard/StyledButton");
const StyledIcon_1 = require("components/Dashboard/StyledIcon");
const tokenHeader_1 = require("tokenHeader");
const graphql_1 = require("./graphql");
const tokenHeader_2 = require("tokenHeader");
const queryDefinitions_1 = require("queryDefinitions");
const Toast_1 = __importDefault(require("components/general/Toast/Toast"));
const useToast_1 = __importDefault(require("components/general/Toast/useToast"));
const xhr_1 = require("./xhr");
const useAccountChange_1 = __importDefault(require("components/useAccountChange"));
const MalomoButton_1 = require("components/Dashboard/MalomoButton");
const MalomoText_1 = require("components/Dashboard/MalomoText");
const leftTab = {
    description: 'all-pages-link',
    label: trackingCopy_1.trackingCopy.tab1,
    link: '/tracking-page/manager/all'
};
const rightTab = {
    description: 'archived-pages-link',
    label: trackingCopy_1.trackingCopy.tab2,
    link: '/tracking-page/manager/archived'
};
const tabs = [leftTab, rightTab];
const pageCount = 12;
const Wrapper = ({ children }) => (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, null,
        react_1.default.createElement(LoadingSpinner_1.default, null)) }, children));
// We should extract the layout to a different file once TPE work is merged
// eslint-disable-next-line react/no-multi-comp
const Layout = () => {
    const [showModal, setShowModal] = react_1.default.useState(false);
    const [detailedPage, setDetailedPage] = react_1.default.useState({});
    const [modalType, setModalType] = react_1.default.useState('');
    const [progress, setProgress] = react_1.default.useState(0);
    const [showPageUpdatedModal, setShowPageUpdatedModal] = react_1.default.useState(false);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'error' does not exist on type '((graphql... Remove this comment to see the full error message
    const [createTrackingPage, { error: createError }] = (0, tokenHeader_1.useAuthedMutationWithAccountId)(graphql_1.CREATE_TRACKING_PAGE);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'error' does not exist on type '((graphql... Remove this comment to see the full error message
    const [getUrl, { error: urlError }] = (0, tokenHeader_1.useAuthedMutationWithAccountId)(graphql_1.GET_S3_URL);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'error' does not exist on type '((graphql... Remove this comment to see the full error message
    const [confirmUpload, { error: confirmationError }] = (0, tokenHeader_1.useAuthedMutationWithAccountId)(graphql_1.CONFIRM_UPLOAD);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'data' does not exist on type '((graphqlV... Remove this comment to see the full error message
    const [deleteTrackingPage, { data: deleteData, error: deleteError }] = (0, tokenHeader_1.useAuthedMutationWithAccountId)(graphql_1.DELETE_TRACKING_PAGE);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'data' does not exist on type '((graphqlV... Remove this comment to see the full error message
    const [archiveTrackingPage, { data: archiveData, error: archiveError }] = (0, tokenHeader_1.useAuthedMutationWithAccountId)(graphql_1.ARCHIVE_TRACKING_PAGE);
    const [unarchiveTrackingPage, 
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'data' does not exist on type '((graphqlV... Remove this comment to see the full error message
    { data: unarchiveData, error: unarchiveError }] = (0, tokenHeader_1.useAuthedMutationWithAccountId)(graphql_1.UNARCHIVE_TRACKING_PAGE);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'error' does not exist on type '((graphql... Remove this comment to see the full error message
    const [updateTrackingPage, { error: updateTrackingPageError }] = (0, tokenHeader_1.useAuthedMutationWithAccountId)(graphql_1.UPDATE_TRACKING_PAGE);
    const { setToastMessage, toastParams } = (0, useToast_1.default)();
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'loading' does not exist on type '((optio... Remove this comment to see the full error message
    const [getAllPages, { loading, error, data }] = (0, tokenHeader_2.useAuthedLazyQuery)(queryDefinitions_1.GET_ALL_PAGES, { fetchPolicy: 'no-cache' });
    const [fetchPages, setFetchPages] = react_1.default.useState(false);
    const navigate = (0, react_router_dom_1.useNavigate)();
    function changePageState(fn) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield fn();
                setFetchPages((f) => !f);
            }
            catch (err) {
                // eslint-disable-next-line no-console
                console.log(err);
                setToastMessage({
                    status: 'error',
                    message: 'Something went wrong. Please try again.'
                });
            }
        });
    }
    (0, useAccountChange_1.default)(() => __awaiter(void 0, void 0, void 0, function* () {
        // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
        yield getAllPages({ variables: { first: pageCount } });
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'boolean' is not assignable to type 'never'.
    }), [fetchPages]);
    function uploadFile(id, url, s3Path, version, fileToUpload) {
        return __awaiter(this, void 0, void 0, function* () {
            const responseSuccess = yield (0, xhr_1.uploadS3File)(url, fileToUpload, version, setProgress);
            if (responseSuccess) {
                // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
                yield confirmUpload({
                    s3Path: s3Path,
                    trackingPageId: id,
                    version: version
                });
            }
            else {
                return Promise.reject();
            }
            return Promise.resolve();
        });
    }
    function handleToggleModal() {
        setProgress(0);
        setShowModal((current) => !current);
    }
    (0, react_1.useEffect)(() => {
        setShowModal(false);
    }, [
        deleteData,
        archiveData,
        unarchiveData,
        confirmationError,
        deleteError,
        archiveError,
        unarchiveError,
        urlError,
        createError,
        updateTrackingPageError
    ]);
    function handleCreatePage() {
        setDetailedPage({});
        setModalType('new');
        handleToggleModal();
    }
    function handleEditPage(page) {
        setDetailedPage(page);
        setModalType('edit');
        handleToggleModal();
    }
    function handleArchivePage(page) {
        setDetailedPage(page);
        setModalType('archive');
        handleToggleModal();
    }
    function handleDeletePage(page) {
        setDetailedPage(page);
        setModalType('delete');
        handleToggleModal();
    }
    function handleRestorePage(page) {
        setDetailedPage(page);
        setModalType('restore');
        handleToggleModal();
    }
    function handleLaunchEditor(page) {
        setDetailedPage(page);
        navigate(`/tracking-page/editor?id=${page.id}`);
    }
    function createPage(name, fileToUpload, hostedDomain) {
        return __awaiter(this, void 0, void 0, function* () {
            changePageState(() => __awaiter(this, void 0, void 0, function* () {
                const { data: { createTrackingPage: { trackingPage: { id } } }
                // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
                 } = yield createTrackingPage({ hostedDomainId: hostedDomain.id, name });
                const { data: { createTrackingPagePayloadSignedUrl: { s3Path, url, version } }
                // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
                 } = yield getUrl({ trackingPageId: id, filename: fileToUpload[0].name });
                yield uploadFile(id, url, s3Path, version, fileToUpload[0]);
                setShowPageUpdatedModal(true);
                setShowModal(false);
            }));
        });
    }
    function restorePage() {
        return __awaiter(this, void 0, void 0, function* () {
            changePageState(() => __awaiter(this, void 0, void 0, function* () {
                // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
                yield unarchiveTrackingPage({ id: detailedPage.id });
                setToastMessage('Page Restored');
            }));
        });
    }
    function deletePage() {
        return __awaiter(this, void 0, void 0, function* () {
            changePageState(() => __awaiter(this, void 0, void 0, function* () {
                // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
                yield deleteTrackingPage({ id: detailedPage.id });
                setToastMessage('Page Deleted');
            }));
        });
    }
    function updatePage(id, name, fileToUpload) {
        return __awaiter(this, void 0, void 0, function* () {
            changePageState(() => __awaiter(this, void 0, void 0, function* () {
                // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
                yield updateTrackingPage({ id, name });
                const { data: { createTrackingPagePayloadSignedUrl: { s3Path, url, version } }
                // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
                 } = yield getUrl({ trackingPageId: id, filename: fileToUpload[0].name });
                yield uploadFile(id, url, s3Path, version, fileToUpload[0]);
                setShowPageUpdatedModal(true);
                setShowModal(false);
            }));
        });
    }
    function archivePage() {
        return __awaiter(this, void 0, void 0, function* () {
            changePageState(() => __awaiter(this, void 0, void 0, function* () {
                // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
                yield archiveTrackingPage({ id: detailedPage.id });
                setToastMessage('Page Archived');
            }));
        });
    }
    let activeTrackingPages, archivedTrackingPages;
    function normalizeTrackingPages(pages) {
        return pages.map((page) => page.node);
    }
    if (data && !loading && !error) {
        activeTrackingPages = data.trackingPages.edges.filter((page) => !page.node.archivedAt);
        activeTrackingPages = normalizeTrackingPages(activeTrackingPages);
        archivedTrackingPages = data.trackingPages.edges.filter((page) => page.node.archivedAt !== null);
        archivedTrackingPages = normalizeTrackingPages(archivedTrackingPages);
    }
    return (react_1.default.createElement("div", { className: 'fade show' },
        react_1.default.createElement(StyledMainContainer_1.StyledMainContainer, null,
            react_1.default.createElement(TrackingPageModal_1.default, { display: showModal, onArchive: archivePage, onCreate: createPage, onDelete: deletePage, onRestore: restorePage, onToggleModal: handleToggleModal, onUpdate: updatePage, page: detailedPage, progress: progress, type: modalType }),
            react_1.default.createElement(SimpleModal_1.default, { body: react_1.default.createElement(MalomoText_1.MalomoText, { paragraph: true }, "Your tracking page is uploaded. Please wait approximately 5 minutes for us to make sure that every inch of the Internet knows about it!"), display: showPageUpdatedModal, header: react_1.default.createElement(MalomoText_1.MalomoText, null, "Your page is uploaded"), hideButtons: true, onToggleModal: () => setShowPageUpdatedModal(false), primaryButton: react_1.default.createElement(MalomoButton_1.MalomoButton, { onClick: () => setShowPageUpdatedModal(false) }, "Close") }),
            react_1.default.createElement("div", null,
                react_1.default.createElement(StyledHeaderContainer_1.StyledHeaderContainer, null,
                    react_1.default.createElement(StyledHeader_1.StyledHeader, null, trackingCopy_1.trackingCopy.mainHeader),
                    react_1.default.createElement(StyledButton_1.StyledButton, { className: 'btn btn-primary', maxWidth: '130px', onClick: handleCreatePage },
                        react_1.default.createElement(StyledIcon_1.StyledIcon, { className: 'fe fe-plus', margin: '10px', white: true }),
                        trackingCopy_1.trackingCopy.button1)),
                react_1.default.createElement(TabNavigation, { tabs: tabs })),
            react_1.default.createElement(Toast_1.default, Object.assign({}, toastParams)),
            react_1.default.createElement(StyledContent_1.StyledContent, null,
                react_1.default.createElement(react_router_dom_1.Outlet, { context: {
                        error: error,
                        loading: loading,
                        onArchivePage: handleArchivePage,
                        onDeletePage: handleDeletePage,
                        onEditPage: handleEditPage,
                        onRestorePage: handleRestorePage,
                        onLaunchEditor: handleLaunchEditor,
                        activeTrackingPages: activeTrackingPages,
                        archivedTrackingPages: archivedTrackingPages
                    } })))));
};
// eslint-disable-next-line react/no-multi-comp
const TrackingPageManager = () => (react_1.default.createElement(react_router_dom_1.Routes, null,
    react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Layout, null), path: '*' },
        react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Wrapper, null,
                react_1.default.createElement(AllPages, null)), path: 'all' }),
        react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Wrapper, null,
                react_1.default.createElement(ArchivedPages, null)), path: 'archived' }),
        react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(react_router_dom_1.Navigate, { to: 'all' }), index: true }))));
exports.default = TrackingPageManager;
